var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameracamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2666 3.30039V3.30039C11.9843 3.30039 11.7285 3.13768 11.6082 2.8834C11.391 2.42328 11.1148 1.83527 10.9513 1.51515C10.7099 1.03914 10.3187 0.762164 9.77682 0.75838C9.76774 0.757623 6.23209 0.757623 6.22301 0.75838C5.68116 0.762164 5.29067 1.03914 5.0485 1.51515C4.88579 1.83527 4.60957 2.42328 4.39238 2.8834C4.27205 3.13768 4.0155 3.30039 3.73398 3.30039V3.30039C2.22346 3.30039 0.999756 4.52409 0.999756 6.03385V10.5261C0.999756 12.0351 2.22346 13.2595 3.73398 13.2595H12.2666C13.7764 13.2595 15.0001 12.0351 15.0001 10.5261V6.03385C15.0001 4.52409 13.7764 3.30039 12.2666 3.30039Z",
    stroke: "#28519E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59456 8.0106C5.5938 9.33722 6.67675 10.4224 8.0011 10.4217C9.32319 10.4202 10.4031 9.33949 10.4054 8.01589C10.4076 6.687 9.32848 5.60405 8.00262 5.60254C6.66918 5.60103 5.58396 6.70213 5.59456 8.0106Z",
    stroke: "#28519E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7101 6.2403C11.637 6.2328 11.5648 6.21372 11.4839 6.18116C11.3939 6.1412 11.316 6.09035 11.2407 6.01385C11.1054 5.86994 11.0271 5.68175 11.0271 5.48761C11.0271 5.38449 11.0482 5.28228 11.0894 5.18969C11.1306 5.09588 11.1795 5.01675 11.2679 4.93068C11.3351 4.87213 11.404 4.82501 11.4981 4.78354C11.7773 4.67292 12.1094 4.73902 12.3169 4.94646C12.3791 5.00774 12.4315 5.08169 12.4605 5.14405L12.4778 5.18827C12.5196 5.28228 12.5406 5.38449 12.5406 5.48761C12.5406 5.68568 12.4633 5.86887 12.3198 6.02135C12.1957 6.14625 12.0328 6.22305 11.859 6.2403L11.7839 6.24402L11.7101 6.2403Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameracamera);
export default __webpack_public_path__ + "static/media/Cameracamera.0c89d7a86a43d9a17832119c93b4bd1d.svg";
export { ForwardRef as ReactComponent };